// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Shapes_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M6.712 5.763a.75.75 0 0 0-1.424 0l-3.75 11.25A.75.75 0 0 0 2.25 18h7.5a.75.75 0 0 0 .712-.987ZM3.29 16.5 6 8.372 8.71 16.5ZM19.5 7.125A4.875 4.875 0 1 0 14.625 12 4.88 4.88 0 0 0 19.5 7.125Zm-8.25 0a3.375 3.375 0 1 1 3.375 3.375 3.375 3.375 0 0 1-3.375-3.375ZM21 13.5h-8.25a.75.75 0 0 0-.75.75v5.25a.75.75 0 0 0 .75.75H21a.75.75 0 0 0 .75-.75v-5.25a.75.75 0 0 0-.75-.75Zm-.75 5.25H13.5V15h6.75Z',
  viewBox: '0 0 24 24',
  glyph: 'Shapes_Stroke2_Corner0_Rounded',
})
